import React, {useEffect, useState} from 'react'
import {observer} from 'mobx-react-lite'
import {Seo} from '../../../../components/seo'
import {Container, Stack, Text, Flex} from '../../../../vanilla'
import {useStoreDetailsStore} from '../../../../store/hooks/useStore'
import {Spinner} from '../../../../components/spinner'
import queryString from 'query-string'
import {storeName} from './styles.css'
import {Link} from '../../../../components/link'
import {StoreDetailResponseItem} from '../../../../types/store/storeDetails'
import {flowResult} from 'mobx'

const ViewAllStoresPage = observer(() => {
  const {getAllStores, allStores} = useStoreDetailsStore()
  const [error, setError] = useState<string | null>(null)
  const [stores, setStores] = useState<StoreDetailResponseItem[]>([])
  const [isLoading, setIsLoading] = useState(true)

  // Fetch new stores if the allStores array is empty
  useEffect(() => {
    const fetchAllStores = async () => {
      try {
        const res = await flowResult(getAllStores()) as StoreDetailResponseItem[]
        setStores(res)
      } catch (e) {
        setError('Failed to load stores. Please try again later.')
      }
      setIsLoading(false)
    }

    if (allStores.length === 0) {
      fetchAllStores()
    } else {
      setStores(allStores)
      setIsLoading(false)
    }
  }, [allStores])

  const buildStoreDetailsUrl = (storeID: string, storeName: string) => {
    const queryParams = {
      StoreID: storeID,
      StoreName: encodeURIComponent(storeName),
    }
    return `/store-finder/store?${queryString.stringify(queryParams)}`
  }

  if (isLoading) {
    return (
    <Flex
      justifyContent="center"
      alignItems="center"
      style={{height: "50vh"}}
    >
      <Spinner color="primary" />
    </Flex>
    )
  }

  if (error) {
    return <Text>{error}</Text>
  }

  return (
    <Container
      paddingTop={['0px', '12px']}
      paddingX={['0px', '16px']}
      paddingBottom={['24px', '36px']}
    >
      <Seo title="All Stores - Iceland Store Finder" />
        <Stack>
          <Text as="h1"
            variant="heading1"
            textAlign="center"
            padding='16px'
          >
            All Stores
          </Text>
          <Stack
            bg="white"
            padding="16px"
          >
            {stores && stores.length ? (
              stores.map(store => (
                <Flex
                  key={store.ID}
                  justifyContent="center"
                  alignItems="center"
                >
                <Text
                  as={Link}
                  to={buildStoreDetailsUrl(store.ID, store.name)}
                  className={storeName}
                  variant='text3'
                >
                  {store.name}
                </Text>
              </Flex>
              ))
            ) : (
              <Text>No stores found in this area.</Text>
            )}
        </Stack>
      </Stack>
    </Container>
  )
})

export default ViewAllStoresPage